var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.deleting)?_c('confirmation-modal',{attrs:{"title":_vm.modalTitle,"bodyText":_vm.modalBody,"buttonText":_vm.__('Delete'),"danger":true},on:{"confirm":_vm.confirmed,"cancel":_vm.cancel}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }